<script setup lang="ts">
import '@/styles';
import { useHead } from '@unhead/vue';

useHead({
  titleTemplate: (title) => (title ? title + ' - ' : '') + $t`Castalian Spring`,
});
</script>

<template>
  <h1>{{ $t`Loading…` }}</h1>
</template>
